<script setup lang="ts">
import { Label } from '@/components/ui/label';
import SearchableSelectMenu from '@/components/ui/searchable-select-menu/SearchableSelectMenu.vue';

withDefaults(defineProps<{
    modelValue: string;
    options: Array<{ value: string; label: string; description?: string }>;
    label?: string;
    recipientLabel?: string;
    recipientName?: string;
    recipientEmail?: string;
    showRecipient?: boolean;
    emptyRecipientLabel?: string;
    description?: string;
    loading?: boolean;
    disabled?: boolean;
}>(), {
    label: 'Delivery method',
    recipientLabel: 'Email recipient',
    showRecipient: false,
    emptyRecipientLabel: 'No recipient email available.',
    description: '',
    loading: false,
    disabled: false,
});
defineEmits<{ 'update:modelValue': [value: string] }>();
const labelId = useId();
</script>

<template>
    <div class="space-y-3">
        <div class="space-y-2">
            <Label :for="labelId">{{ label }}</Label>
            <SearchableSelectMenu
                :id="labelId"
                :model-value="modelValue"
                :options="options"
                :disabled="disabled || loading"
                show-all-by-default
                variant="form"
                @update:model-value="$emit('update:modelValue', String($event))"
            />
        </div>
        <p v-if="description" class="text-sm leading-6 text-muted-foreground">{{ description }}</p>
        <div v-if="showRecipient" class="space-y-1">
            <p class="text-xs font-medium text-muted-foreground">{{ recipientLabel }}</p>
            <p v-if="recipientEmail" class="break-words text-sm text-foreground">{{ recipientName ? `${recipientName} · ` : '' }}{{ recipientEmail }}</p>
            <p v-else class="text-sm text-destructive" role="status">{{ emptyRecipientLabel }}</p>
        </div>
        <slot />
    </div>
</template>
